import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { StorageItem, StorageItemProcessor } from '@vsolv/packages/storage/domain';
import { BadgeModule } from '@vsolv/vectors-ui/badge';
import { IconsModule } from '@vsolv/vectors-ui/icons';
import { ThemingModule } from '@vsolv/vectors-ui/theming';
import { TooltipModule } from '@vsolv/vectors-ui/tooltip';
import { statusBadgeConfig } from '../../utils';

@Component({
  standalone: true,
  selector: 'vs-storage-item-status-badge',
  templateUrl: './item-status-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, BadgeModule, ThemingModule, TooltipModule, IconsModule],
})
export class ItemStatusBadgeComponent {
  @HostBinding('class') protected _class = 'inline-block cursor-default';

  @Input() hideTooltip = false;

  @Input() item?: StorageItem.Model | null;
  @Input() processingResults?: StorageItemProcessor.Result[] | null;

  protected get results() {
    return this.item?.processingResults ?? this.processingResults ?? [];
  }

  protected get status() {
    return statusBadgeConfig(this.results);
  }

  protected get processors() {
    return [...new Set(this.results.map(result => result.processorId))].map(id => {
      const status = statusBadgeConfig(this.results.filter(result => result.processorId === id));
      const processor = this.results.find(result => result.processorId === id)?.processor;
      return { label: processor?.name ?? id, theme: status.theme };
    });
  }
}
